module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "angular2-modal"
// module id = 0
// module chunks = 0